import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/quotations'
        }
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/quotations'
        }
      }
    },
    {
      path: '/prospecting',
      name: 'prospecting',
      component: () => import(/* webpackChunkName: "prospecting" */ '@/views/Prospecting.vue'),
      meta: {
        title: Vue.i18n.translate('strings.prospecting', null),
        auth: true
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import(/* webpackChunkName: "Customers" */ '@/views/Customers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: true
      }
    },
    {
      path: '/customers/:id/details',
      name: 'customersDetailsShow',
      component: () => import(/* webpackChunkName: "CustomerDeatils" */ '@/views/CustomerDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "Users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/quotations'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import(/* webpackChunkName: "Suppliers" */ '@/views/Suppliers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.suppliers', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'supplierDetail',
        component: () => import(/* webpackChunkName: "Suppliers" */ '@/views/Suppliers.vue')
      }]
    },
    {
      path: '/suppliers/:id/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "supplier_contacts" */ '@/views/SupplierContacts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.contacts', null),
        auth: true
      }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import(/* webpackChunkName: "Products" */ '@/views/Products.vue'),
      meta: {
        title: Vue.i18n.translate('strings.products', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'productDetail',
        component: () => import(/* webpackChunkName: "Products" */ '@/views/Products.vue')
      }]
    },
    {
      path: '/mining-groups',
      name: 'miningGroups',
      component: () => import(/* webpackChunkName: "MiningGroups" */ '@/views/MiningGroups.vue'),
      meta: {
        title: Vue.i18n.translate('strings.mining_groups', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'miningGroupDetail',
        component: () => import(/* webpackChunkName: "MiningGroups" */ '@/views/MiningGroups.vue')
      }]
    },
    {
      path: '/quotations',
      name: 'quotations',
      component: () => import(/* webpackChunkName: "Quotations" */ '@/views/Quotations.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotations', null),
        auth: true
      }
    },
    {
      path: '/quotations/new',
      name: 'newQuotation',
      component: () => import(/* webpackChunkName: "Quotations" */ '@/views/QuotationsDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.quotations.detail', null),
        auth: true
      }
    },
    {
      path: '/quotations/:id',
      name: 'editQuotation',
      component: () => import(/* webpackChunkName: "Quotations" */ '@/views/QuotationsDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotations.detail', null),
        auth: true
      }
    },
    {
      path: '/purchase-orders',
      name: 'purchaseOrders',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/PurchaseOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: true
      }
    },
    {
      path: '/purchase-orders/new',
      name: 'newPurchaseOrder',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/PurchaseOrdersDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders,detail', null),
        auth: true
      }
    },
    {
      path: '/purchase-orders/:id',
      name: 'editPurchaseOrder',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/PurchaseOrdersDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders.detail', null),
        auth: true
      }
    },
    {
      path: '/purchase-orders/:id/receptions',
      name: 'receptions',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/Receptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders.receptions', null),
        auth: true
      }
    },
    {
      path: '/sales',
      name: 'sales',
      component: () => import(/* webpackChunkName: "Sales" */ '@/views/Sales.vue'),
      meta: {
        title: Vue.i18n.translate('strings.sales', null),
        auth: true
      },
      children: [
        {
          path: ':id',
          name: 'saleDetail',
          component: () => import(/* webpackChunkName: "Sales" */ '@/views/Sales.vue')
        }
      ]
    },
    {
      path: '/sales/details/:id',
      name: 'salesDetailsShow',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/SalesDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.sales', null),
        auth: true
      }
    },
    {
      path: '/sales/:id/sending-receptions',
      name: 'saleSendingReceptions',
      component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/views/SendingReceptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.sales', null),
        auth: true
      }
    },
    {
      path: '/commissions',
      name: 'commissions',
      component: () => import(`@/views/Commissions${process.env.VUE_APP_COMMISSION_VERSION}.vue`),
      meta: {
        title: Vue.i18n.translate('strings.commissions', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'commissionDetail',
        component: () => import('@/views/Commissions.vue')
      }]
    },
    {
      path: '/customers/:customerId/addresses/',
      name: 'addresses',
      component: () => import(/* webpackChunkName: "customer_addresses" */ '@/views/CustomerAddresses.vue'),
      meta: {
        title: Vue.i18n.translate('strings.addresses', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'customerAddressesDetail',
        component: () => import(/* webpackChunkName: "customer_addresses" */ '@/views/CustomerAddresses.vue')
      }]
    },
    {
      path: '/customers/:customerId/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "customer_contacts" */ '@/views/CustomerContacts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.contacts', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'customerContactsDetail',
        component: () => import(/* webpackChunkName: "customer_contacts" */ '@/views/CustomerContacts.vue')
      }]
    },
    {
      path: '/product_categories',
      name: 'product_categories',
      component: () => import(/* webpackChunkName: "product_categories" */ '@/views/ProductCategories.vue'),
      meta: {
        title: Vue.i18n.translate('strings.product_categories', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'productCategoriesDetail',
        component: () => import(/* webpackChunkName: "product_categories" */ '@/views/ProductCategories.vue')
      }]
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks.vue'),
      meta: {
        title: Vue.i18n.translate('strings.tasks', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'tasksDetail',
        component: () => import(/* webpackChunkName: "tasks" */ '@/views/Tasks.vue')
      }]
    },
    {
      path: '/sale_tracings',
      name: 'sale_tracings',
      component: () => import(/* webpackChunkName: "sale_tracings" */ '@/views/SaleTracings.vue'),
      meta: {
        title: Vue.i18n.translate('strings.sale_tracings', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'saleTracingsDetail',
        component: () => import(/* webpackChunkName: "sale_tracings" */ '@/views/SaleTracings.vue')
      }]
    },
    // New Route
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
